import { useTranslation } from 'react-i18next';
import { StoryCardTeaserImageStyle, StoryHighlightingCommentsMode } from '../../../../../services';
import { FilterGroupItemsAlignment, FilterValue, useCardFilter } from '../../../../../shared';

export const useCreateStoryCardFilter = (filter: FilterValue[]) => {
  const { t } = useTranslation();

  const { t: ctxT } = useTranslation('', { keyPrefix: 'createStorySettings' });

  const { groups: cardGroups } = useCardFilter({ filter });

  return {
    groups: [
      ...cardGroups,
      {
        id: 'highlightingComments',
        title: ctxT('featured-comments'),
        itemsAlignment: FilterGroupItemsAlignment.ROW,
        items: [
          {
            id: StoryHighlightingCommentsMode.MOST_LIKEABLE,
            label: ctxT('featured-comments-most-liked'),
            value: StoryHighlightingCommentsMode.MOST_LIKEABLE,
          },
          {
            id: StoryHighlightingCommentsMode.MANUAL,
            label: ctxT('featured-comments-manual'),
            value: StoryHighlightingCommentsMode.MANUAL,
          },
          {
            id: StoryHighlightingCommentsMode.FIRST,
            label: ctxT('featured-comments-first'),
            value: StoryHighlightingCommentsMode.FIRST,
          },
        ],
      },
      {
        id: 'teaserStyle',
        title: t('common.teaser-style'),
        itemsAlignment: FilterGroupItemsAlignment.ROW,
        items: [
          {
            id: StoryCardTeaserImageStyle.STANDARD,
            label: t('teasers.standard'),
            value: StoryCardTeaserImageStyle.STANDARD,
          },
          {
            id: StoryCardTeaserImageStyle.SMALL_WITH_TEXT,
            label: t('teasers.small'),
            value: StoryCardTeaserImageStyle.SMALL_WITH_TEXT,
          },
          {
            id: StoryCardTeaserImageStyle.SMALL_WITHOUT_TEXT,
            label: t('teasers.small-without-text'),
            value: StoryCardTeaserImageStyle.SMALL_WITHOUT_TEXT,
          },
          {
            id: StoryCardTeaserImageStyle.BIG_WITHOUT_TEXT,
            label: t('teasers.large'),
            value: StoryCardTeaserImageStyle.BIG_WITHOUT_TEXT,
          },
        ],
      },
    ],
  };
};
